// Curated heading/body font pairings white-label firms can choose from. Keep in
// sync with the `font_preset` choices on ProfessionalGroup (backend) and the
// matching file in the advisor_dashboard app. Any family referenced here must be
// loaded via a <link> in public/index.html.

export type FontPreset =
  | 'timeless'
  | 'editorial'
  | 'modern'
  | 'classic'
  | 'friendly';

export const DEFAULT_FONT_PRESET: FontPreset = 'timeless';

const SANS =
  '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"';
const JAKARTA =
  '"Plus Jakarta Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif';

export interface FontPairing {
  heading: string;
  body: string;
}

interface FontPresetOption extends FontPairing {
  label: string;
  // Human-readable family names for the picker UI (e.g. "Fraunces · Inter").
  headingName: string;
  bodyName: string;
}

export const FONT_PRESETS: Record<FontPreset, FontPresetOption> = {
  timeless: {
    label: 'Timeless',
    headingName: 'Instrument Serif',
    bodyName: 'Inter',
    heading: '"Instrument Serif", Georgia, serif',
    body: SANS,
  },
  editorial: {
    label: 'Editorial',
    headingName: 'Fraunces',
    bodyName: 'Inter',
    heading: '"Fraunces", Georgia, serif',
    body: SANS,
  },
  modern: {
    label: 'Modern',
    headingName: 'Plus Jakarta Sans',
    bodyName: 'Plus Jakarta Sans',
    heading: JAKARTA,
    body: JAKARTA,
  },
  classic: {
    label: 'Classic',
    headingName: 'Lora',
    bodyName: 'Inter',
    heading: '"Lora", Georgia, serif',
    body: SANS,
  },
  friendly: {
    label: 'Friendly',
    headingName: 'Poppins',
    bodyName: 'Inter',
    heading: '"Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif',
    body: SANS,
  },
};

export const getFontPairing = (preset?: FontPreset | null): FontPairing => {
  const option =
    (preset && FONT_PRESETS[preset]) || FONT_PRESETS[DEFAULT_FONT_PRESET];
  return { heading: option.heading, body: option.body };
};
